// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5a8d542c","455":"b9a67b34","977":"23ca7357"}[chunkId] + ".chunk.js";
};